<template>
  <UiModalContainer
    footer-classes="flex justify-end gap-3"
    :modal-show="modal"
    :modal-width="30"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span>{{ heading }}</span>
    </template>
    <div>
      <div v-if="details">
        <span>{{ details }}</span>
      </div>
    </div>
    <template v-slot:footer>
      <div class="flex gap-3 rtl:gap-x-4">
        <UIButton @click="handleClick('close')">Cancel</UIButton>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'

export default {
  components: {
    UiModalContainer,
    UIButton,
  },
  props: {
    modal: { type: Boolean, default: false },
    heading: { type: String, default: '' },
    details: { type: String, default: '' },
  },
  emits: ['cancel'],

  data() {
    return {}
  },
  methods: {
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('cancel')
          break
      }
    },
  },
}
</script>
